import type { QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { patchTicketCreate } from "@sd/lib/patchTicketCreate";

/** PATCH `/service_desk/ticket_create/{id}/` with `assigned_to` (user UUID). */
export async function putTicketAssignedTo(
  queryClient: QueryClient,
  ticketId: string,
  assignedToUuid: string | null,
  extraFields?: Record<string, unknown>
): Promise<boolean> {
  try {
    const ok = await patchTicketCreate(queryClient, ticketId, {
      assigned_to: assignedToUuid,
      ...extraFields,
    });
    if (!ok) {
      toast.error("Assignment could not be saved.");
      return false;
    }
    return true;
  } catch {
    toast.error("Assignment could not be saved.");
    return false;
  }
}
